import { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import axios from "axios";

import "./entries.css";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import FormsView from "./FormsView";

const MASTER_REGEX = /^\d{3}-\d{8}$/;
const API_URL = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/getMaster`;

function Entries() {
  const [masterValue, setMasterValue] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("input");
  const [error, setError] = useState("");

  const getUserId = () => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user?.id || 1;
  };

  const showAlert = (title, icon, iconColor) =>
    Swal.fire({
      title,
      icon,
      iconColor,
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    });

  const validateMaster = () => {
    if (!masterValue.trim()) return "Este campo es obligatorio";
    if (!MASTER_REGEX.test(masterValue)) return "Formato de master invalido";
    return "";
  };

  const handleMaster = async () => {
    const validationError = validateMaster();
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setLoading(true);

    try {
      const { data: res } = await axios.get(API_URL, {
        params: {
          master: masterValue,
          user_id: getUserId(),
        },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
        },
      });

      if (res?.code === 1) {
        setData(res.data || {});
        setTimeout(() => {
          setView("forms");
          setLoading(false);
        }, 1000);
        return;
      }

      if (res?.code === -1) {
        setLoading(false);
        showAlert(
          "La master no existe favor de verificar",
          "warning",
          "#FCC732",
        );
      }
    } catch (err) {
      console.error("Error fetching master:", err);
      setLoading(false);
      showAlert("Hubo un error inesperado", "error", "#f90034");
    }
  };

  const handleMasterChange = ({ target: { value } }) => {
    const numbersOnly = value.replace(/\D/g, "").slice(0, 11);
    const formatted =
      numbersOnly.length > 3
        ? `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`
        : numbersOnly;

    setMasterValue(formatted);
    setError("");
  };

  return (
    <>
      <Helmet>
        <title>Horus | Entrada</title>
      </Helmet>

      <ScrollToTop />

      <div className="container-fluid">
        {view === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                value={masterValue}
                onChange={handleMasterChange}
                maxLength={12}
                onKeyDown={(e) => e.key === "Enter" && handleMaster()}
              />

              {error && <small className="text-danger">{error}</small>}

              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleMaster}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}

        {view === "forms" && data && (
          <FormsView master={data} loading={loading} setLoading={setLoading} />
        )}
      </div>

      <Modal
        show={loading}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Entries;
